import { format } from 'date-fns';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../@casino/ui/table';
import { setGetMailing } from '../../../../store/mailing/thunk/setGetMailing';

const General = () => {
    const dispatch = useDispatch();

    const mailing = useSelector((state) => state.mailing.list);

    const columns = [
        { id: 'id', label: 'id'},
        { id: 'mailing_date_at', label: 'Дата рассылки'},
        { id: 'label', label: 'Наименование'},
        { id: 'description', label: 'Описание'},
        { id: 'track_date_from_at', label: 'Отслеживание С'},
        { id: 'track_date_to_at', label: 'Отслеживание ПО'},
        { id: 'is_start', label: 'Статус'}
    ];

    
    const getRows = (list) => {
        return list.map((item) => {
            return {
                id: item.id,
                mailing_date_at: format(new Date(Number(item.mailing_date_at)), 'dd.MM.yyyy'),
                label: item.label,
                description: item.description,
                track_date_from_at: item.track_date_from_at ? format(new Date(Number(item.track_date_from_at)), 'dd.MM.yyyy') : '-',
                track_date_to_at: item.track_date_to_at ? format(new Date(Number(item.track_date_to_at)), 'dd.MM.yyyy') : '-',
                is_start: item?.is_start ? 'Запущена' : 'Не запущена'
            }
        })
    }

    const rows = React.useMemo(() => getRows(mailing.data), [mailing.data]);

    return (
        <div style={{
            padding: 10,
            background: '#1b2039',
            margin: '12px 0',
            display: 'flex',
            alignItems: 'center',
            borderRadius: 8
        }}>
            <TableCasino
                route="/mailing/view/"
                pagination
                allPage={mailing.pagination.totalPage}
                width={"100%"}
                perPage={10}
                columns={columns}
                rows={rows}
                changePage={(v) => {
                    dispatch(setGetMailing({
                        page: Number(v.page) + 1,
                        pageSize: v.rowsPerPage
                    }))
                }}
                changeRowsPerPage={(v) => {
                    dispatch(setGetMailing({
                        page: 1,
                        pageSize: v.rowsPerPage
                    }))
                }}
            />
        </div>
    )
}

export default General;